import AreaContainer from "../AreaContainer";
import globalStyles from '../result.module.css';
import styles from './assetManagers.module.css'
import AgentsList from "../Agents/AgentsList";

const AssetManagers = ({ asset_managers, centre_managers, sponsored, id, type, property, isLoggedIn, bid, payingClient, showAllAgentContacts }) => {
    if (asset_managers && asset_managers.length === 0 && centre_managers && centre_managers.length === 0) return null;
    const contactable = true;
    let agentsContactable = !contactable && !bid && !sponsored && !payingClient;
    return (
        <AreaContainer area="assetManagers" style={null} extraClass={null}>
            <div className={styles.DemoWrapper}>
                <h2 className={globalStyles.subTitleText}>Additional Contacts</h2>
                <div className={styles.container}>
                    {(asset_managers && asset_managers.length > 0) && (
                        <AgentsList contactType={'asset_managers'} showRibbon={false} contactButtonAll={false} isLoggedIn={isLoggedIn} property={property} showAllAgentContacts={showAllAgentContacts} agents={asset_managers} contactable={!agentsContactable} sponsored={sponsored} id={id} type={type} display="agents" title={"Asset Managers"} />
                    )}
                    {
                        (centre_managers && centre_managers.length > 0) && (
                            <AgentsList contactType={'centre_managers'} showRibbon={false} contactButtonAll={false} isLoggedIn={isLoggedIn} property={property} showAllAgentContacts={showAllAgentContacts} agents={centre_managers} contactable={!agentsContactable} sponsored={sponsored} id={id} type={type} display="agents" title={"Center Managers"} />
                        )
                    }
                </div>
            </div>
        </AreaContainer>
    )
}

export default AssetManagers;